<template>
  <div class="p-42 my-52 insights-container">
    <div class="relative">
      <div @click.prevent="showVideo" class="absolute-header" style="top: -17px; right: 0">
        <div class="button-header flex-mid">
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <div>
      <div class="fs-18 fw-900 fc-15253C">
        {{ $t('weQuarterlyInsights.strengths.whatAreOur') }}
      </div>
      <div class="fc-15253C opa-07 fs-14 ">
        {{ $t('weQuarterlyInsights.strengths.keyAreasOf') }}
      </div>
    </div>
    <div
      v-if="loadingStrengthData && enpsQusetionData.length == 0"
      class="strengths-card mt-22 relative"
      style="background-color: #784aad"
    >
      <div>
        <div class="fc-FFFFFF mt-10 relative">
          <div class="icon-status flex-mid opa-04"><span class="opa-05">⌛</span></div>
          <div class="flex-center">
            <div
              class="py-8 px-12 image-skeleton opa-02"
              style="border-radius: 6px"
            >
              eNPS
            </div>
            <div
              class="fs-16 fw-900 ml-8 text-skeleton opa-04"
              style="width: 380px"
            >
              &nbsp;
            </div>
          </div>
          <div
            id="strengths-table"
            class="mt-14"
            style="width: 85%; height: 280px"
          >
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="!loadingStrengthData && enpsQusetionData.length !== 0"
      class="strengths-card mt-22 relative"
      style="background-color: #784aad"
    >
      <div v-for="(data, index) in enpsQusetionData" :key="data.id" class="">
        <div
          v-if="index == enpsQusetionDataShowTable"
          class="fc-FFFFFF mt-10 relative"
        >
          <div class="icon-status flex-mid">
            {{ data.icon }}
          </div>
          <span v-if="(questionType[data.id] == 'NPS' || questionType[data.id] == 'eNPS')" :class="`py-8 px-12 enps-span box-${data.indexColor}`" >{{ questionType[data.id] }}</span>
          <span v-else-if="(data.id == 'WHO-5' || data.id == 'eRes' || data.id == 'Culture')" :class="`py-8 px-12 enps-span box-${data.indexColor}`" >{{ data.id }}</span>
          <span class="fs-16 fw-900 ml-8">{{ data.questionTitile }}</span>
          <div id="strengths-table" class="flex mt-14" style="width: 85%">
            <el-table
              :data="data.tableData"
              style="width: 100%; margin-bottom: 16px"
              row-key="id"
              border
              default-expand-all
              :tree-props="{ children: 'children' }"
            >
              <el-table-column
                prop="teamName"
                label=""
                header-align="center"
                class-name="text-box text-team-label"
                label-class-name="text-label remove-bg"
              ></el-table-column>
              <el-table-column
                :label="recommendLabel.q1Label"
                width="90"
                header-align="center"
                class-name="text-box"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q1Status}`"
                  >
                    <div :class="`ml-auto fc-FFFFFF fs-13 ${scope.row.q1SChange? '' : 'mr-auto'}`">{{
                      renderCellData(scope.row.q1, data.id)
                    }}</div>
                    <img v-if="scope.row.q1SChange && scope.row.q1SChange == 'up'" :src="$utils('icons', 'arrow_up_white_32dp')" alt="">
                    <img v-else-if="scope.row.q1SChange && scope.row.q1SChange == 'down'" :src="$utils('icons', 'arrow_down_white_32dp')" alt="">
                    <img v-else-if="scope.row.q1SChange && scope.row.q1SChange == 'minus'" :src="$utils('icons', 'no_change_white_32dp')" alt="">
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="recommendLabel.q2Label"
                width="90"
                header-align="center"
                class-name="text-box"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q2Status}`"
                  >
                    <div class="fc-FFFFFF mx-auto">{{
                      renderCellData(scope.row.q2, data.id)
                    }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="recommendLabel.q3Label"
                width="90"
                class-name="text-box"
                header-align="center"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q3Status}`"
                  >
                    <div class="fc-FFFFFF mx-auto">{{
                      renderCellData(scope.row.q3, data.id)
                    }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="recommendLabel.q4Label"
                width="90"
                header-align="center"
                class-name="text-box"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q4Status}`"
                  >
                    <div class="fc-FFFFFF mx-auto">{{
                      renderCellData(scope.row.q4, data.id)
                    }}</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="flex-center">
        <div style="width: 85%">
          <div class="flex-mid pagination">
            <div
              v-for="(value, index) in enpsQusetionData.length"
              :key="value + '_paination_point'"
              :class="`point ${
                index == enpsQusetionDataShowTable ? '' : 'opa-02'
              }`"
            ></div>
          </div>
        </div>
        <div class="flex ml-auto position-arrow">
          <div
            :class="`arrow left flex-mid ${
              enpsQusetionDataShowTable == 0 ? 'hide' : ''
            }`"
            @click="changeEnpsTable(enpsQusetionDataShowTable == 0, 'back')"
          >
            <img
              style="width: 26px; height: 26px"
              src="../../assets/icons/black_chevron_left@2x.png"
              alt=""
            />
          </div>
          <div
            :class="`arrow right flex-mid ${
              enpsQusetionDataShowTable == enpsQusetionData.length - 1
                ? 'hide'
                : ''
            }`"
            @click="
              changeEnpsTable(
                enpsQusetionDataShowTable == enpsQusetionData.length - 1,
                'next'
              )
            "
          >
            <img
              style="width: 26px; height: 26px"
              src="../../assets/icons/black_chevron_right@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="loadingStrengthData && normalQusetionData.length == 0"
      class="strengths-card mt-22 relative"
      style="background-color: #ad4a83"
    >
      <div>
        <div class="fc-FFFFFF mt-10 relative">
          <div class="icon-status flex-mid opa-04"><span class="opa-05">⌛</span></div>
          <div class="flex-center">
            <div
              class="py-8 px-12 image-skeleton opa-02"
              style="border-radius: 6px"
            >
              eNPS
            </div>
            <div
              class="fs-16 fw-900 ml-8 text-skeleton opa-04"
              style="width: 380px"
            >
              &nbsp;
            </div>
          </div>
          <div
            id="strengths-table"
            class="mt-14"
            style="width: 85%; height: 280px"
          >
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
            <div class="flex">
              <div
                class="image-skeleton opa-005 m-3"
                style="height: 42px; width: 212px"
              >
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
              <div class="image-skeleton opa-01 m-3" style="width: 84px">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="!loadingStrengthData && normalQusetionData.length !== 0"
      class="strengths-card mt-22 relative"
      style="background-color: #ad4a83"
    >
      <div v-for="(data, index) in normalQusetionData" :key="data.id" class="">
        <div
          v-if="index == normalQusetionDataShowTable"
          class="fc-FFFFFF mt-10 relative"
        >
          <div class="icon-status flex-mid">
            {{ data.icon }}
          </div>
          <span v-if="(questionType[data.id] == 'NPS' || questionType[data.id] == 'eNPS')" :class="`py-8 px-12 enps-span box-${data.indexColor}`" >{{ questionType[data.id] }}</span>
          <span v-else-if="(data.id == 'WHO-5' || data.id == 'eRes' || data.id == 'Culture')" :class="`py-8 px-12 enps-span box-${data.indexColor}`" >{{ data.id }}</span>
          <span class="fs-16 fw-900 ml-8">{{ data.questionTitile }}</span>
          <div id="strengths-table" class="flex mt-14" style="width: 85%">
            <el-table
              :data="data.tableData"
              style="width: 100%; margin-bottom: 16px"
              row-key="id"
              border
              default-expand-all
              :tree-props="{ children: 'children' }"
            >
              <el-table-column
                prop="teamName"
                label=""
                header-align="center"
                class-name="text-box text-team-label"
                label-class-name="text-label remove-bg"
              ></el-table-column>
              <el-table-column
                :label="recommendLabel.q1Label"
                width="90"
                header-align="center"
                class-name="text-box"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q1Status}`"
                  >
                    <div :class="`ml-auto fc-FFFFFF fs-13 ${scope.row.q1SChange? '' : 'mr-auto'}`">{{
                      renderCellData(scope.row.q1, data.id)
                    }}</div>
                    <img v-if="scope.row.q1SChange && scope.row.q1SChange == 'up'" :src="$utils('icons', 'arrow_up_white_32dp')" alt="">
                    <img v-else-if="scope.row.q1SChange && scope.row.q1SChange == 'down'" :src="$utils('icons', 'arrow_down_white_32dp')" alt="">
                    <img v-else-if="scope.row.q1SChange && scope.row.q1SChange == 'minus'" :src="$utils('icons', 'no_change_white_32dp')" alt="">
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="recommendLabel.q2Label"
                width="90"
                header-align="center"
                class-name="text-box"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q2Status}`"
                  >
                    <div class="fc-FFFFFF mx-auto">{{
                      renderCellData(scope.row.q2, data.id)
                    }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="recommendLabel.q3Label"
                width="90"
                class-name="text-box"
                header-align="center"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q3Status}`"
                  >
                    <div class="fc-FFFFFF mx-auto">{{
                      renderCellData(scope.row.q3, data.id)
                    }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="recommendLabel.q4Label"
                width="90"
                header-align="center"
                class-name="text-box"
                label-class-name="text-label"
              >
                <template slot-scope="scope">
                  <div
                    :class="`flex-center center box-value box-${scope.row.q4Status}`"
                  >
                    <div class="fc-FFFFFF mx-auto">{{
                      renderCellData(scope.row.q4, data.id)
                    }}</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="flex-center">
        <div style="width: 85%">
          <div class="flex-mid pagination">
            <div
              v-for="(value, index) in normalQusetionData.length"
              :key="value + '_paination_point'"
              :class="`point ${
                index == normalQusetionDataShowTable ? '' : 'opa-02'
              }`"
            ></div>
          </div>
        </div>
        <div class="flex ml-auto position-arrow">
          <div
            :class="`arrow left flex-mid ${
              normalQusetionDataShowTable == 0 ? 'hide' : ''
            }`"
            @click="changeNormalTable(normalQusetionDataShowTable == 0, 'back')"
          >
            <img style="width: 26px; height: 26px" :src="$utils('icons', 'black_chevron_left')" alt="">
          </div>
          <div
            :class="`arrow right flex-mid ${
              normalQusetionDataShowTable == normalQusetionData.length - 1
                ? 'hide'
                : ''
            }`"
            @click="
              changeNormalTable(
                normalQusetionDataShowTable == normalQusetionData.length - 1,
                'next'
              )
            "
          >
            <img style="width: 26px; height: 26px" :src="$utils('icons', 'black_chevron_right')" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user'],
  created() {

    this.$store.dispatch("quarterlyStrength/getQuestionMaster");
    this.$store.dispatch("quarterlyStrength/getQuaterHeader",this.user);
    this.$store.dispatch("quarterlyStrength/getDataStrength",this.user);
  },
  computed: {
    recommendLabel() {
      return this.$store.getters["quarterlyStrength/recommendLabel"];
    },
    loadingStrengthData() {
      return this.$store.getters["quarterlyStrength/loadingStrengthData"];
    },
    enpsQusetionData() {
      return this.$store.getters["quarterlyStrength/enpsQusetionData"];
    },
    normalQusetionData() {
      return this.$store.getters["quarterlyStrength/normalQusetionData"];
    },
    questionType() {
      return this.$store.getters["quarterlyStrength/questionType"];
    },
  },
  data() {
    return {
      enpsQusetionDataShowTable: 0,
      normalQusetionDataShowTable: 0,
    };
  },
  methods: {
    renderCellData(value, id){
      let text = ''
      if((this.questionType[id] == 'NPS' || this.questionType[id] == 'eNPS') && value > 0 ){
        text+= '+'
      }
      if(value == '-'){
        text+= '-'
      }else{
        text+= value + (this.questionType[id] == 'Scale' || this.questionType[id] == 'NPS' || this.questionType[id] == 'eNPS' || this.questionType[id] == 'WHO-5' || this.questionType[id] == 'eRes' || this.questionType[id] == 'Culture' ? '' : '%')
      }
      return text
    },
    changeEnpsTable(hide, value) {
      let newPage = this.enpsQusetionDataShowTable;
      if (this.enpsQusetionData.length > newPage > 0) {
        if (!hide && value == "back") {
          this.enpsQusetionDataShowTable = newPage - 1;
        } else if (!hide && value == "next") {
          this.enpsQusetionDataShowTable = newPage + 1;
        }
      }
    },
    changeNormalTable(hide, value) {
      let newPage = this.normalQusetionDataShowTable;
      if (this.normalQusetionData.length > newPage > 0) {
        if (!hide && value == "back") {
          this.normalQusetionDataShowTable = newPage - 1;
        } else if (!hide && value == "next") {
          this.normalQusetionDataShowTable = newPage + 1;
        }
      }
    },
    showVideo() {
      this.$emit("dialogValue", {value:true, text: "section-2"})
    }
  },
};
</script>

<style lang="scss" scoped>
.strengths-card {
  border-radius: 23px;
  padding: 12px 12px 16px 24px;
  .enps-span {
    // background-color: #16d895;
    border: 1px solid #707070;
    border-radius: 6px;
  }
  .box-green {
    background-color: #27bc6c;
  }
  .box-yellow {
    background-color: #ffba0d;
  }
  .box-red {
    background-color: #f22f3c;
  }
  .icon-status {
    position: absolute;
    right: 0px;
    top: -10px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background-color: rgba($color: #000, $alpha: 0.3);
  }
  #strengths-table {
    > div {
      border: 0px;
    }
    .el-table__header-wrapper {
      border: 0px;
      background-color: transparent;
      background-color: red;
    }
    .el-table th.is-leaf,
    .el-table tr {
      border: 0px;
      background-color: transparent;
      background-color: red;
    }
    .box-value {
      // padding: 9px 0;
      height: 42px;
    }
    // .box-green {
    //   background-color: #27bc6c;
    // }
    // .box-yellow {
    //   background-color: #ffba0d;
    // }
    // .box-red {
    //   background-color: #f22f3c;
    // }
    .box-none {
      background-color: rgba($color: #ffffff, $alpha: 0.2);
    }
  }
  .pagination {
    margin-left: 15%;
    .point {
      width: 8px;
      height: 8px;
      border-radius: 8px;
      margin: 0 4px;
      transition: 0.3s;
      background-color: #fff;
    }
  }
  .position-arrow {
    position: absolute;
    bottom: 44px;
    right: 10px;
    .arrow {
      transition: 0.2s;
      width: 32px;
      height: 32px;
      border-radius: 32px;
      box-shadow: 0 0 6px #00000029;
      cursor: pointer;
      background-color: #ffffff;
      &:hover {
        box-shadow: 0 0 3px #00000049;
      }
    }
    .arrow.left {
      margin: 0 4px 0 10px;
    }
    .arrow.right {
      margin: 0 10px 0 4px;
    }
    .arrow.hide {
      opacity: 0.2;
      cursor: default;
    }
  }
}
</style>

<style lang="scss">
#strengths-table {
  > div {
    border: 0px;
  }
  .el-table {
    background-color: transparent;
    .cell {
      padding: 0;
    }
  }
  .el-table__header-wrapper {
    border: 0px;
  }
  .el-table th.is-leaf,
  .el-table tr {
    border: 0px !important;
    background-color: transparent;
    // background-color: rgba($color: #000000, $alpha: 0.1);
  }
  .el-table__expand-icon,
  .el-table--border th:first-child .cell,
  .el-table--border td:first-child .cell {
    color: #fff;
    border: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .el-table__expand-icon {
    margin: 4px 3px -6px 3px;
  }
  .el-table th.is-leaf,
  .el-table td {
    border: 0px;
  }
  .el-table--group::after,
  .el-table--border::after {
    width: 0px;
  }
  .text-box {
    background-color: transparent;
    padding: 3px;
  }
  .text-team-label {
    > .cell {
      background-color: rgba($color: #000, $alpha: 0.1);
      height: 42px;
      padding: 8px 4px;
    }
  }
  .remove-bg {
    > .cell {
      background-color: rgba($color: #000, $alpha: 0);
      height: 20px;
      padding: 0;
    }
  }
  .text-label {
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    background-color: transparent;
  }
}
</style>